// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__316yW","title":"Header_title__1KJmw","side":"Header_side__1TAEx"};